var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getAttributesActive)?_c('section',{staticClass:"attribute-listing-filters"},[_c('div',{staticClass:"attribute-listing-filters-wrapper"},[(_vm.getListingAttributeGroupCombos.length > 0)?_c('BaseGroupListingFilters',{attrs:{"base-group-combos":_vm.getListingAttributeGroupCombos}}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }